import { flow } from 'mobx-state-tree';

import { getStores } from '../..';

export const fetchCategoryList = flow(function* (self) {
  const { config } = getStores(self, 'config');

  if (config.gysService.useMock) return;

  try {
    const response = yield fetch(
      `${config.gysService.url}/get-your-spot/categories`,
      {
        crossDomain: true,
        credentials: 'include',
      },
    );

    const json = yield response.json();
    self.list = json.reverse();
  } catch (error) {
    if (error.message !== 'The user aborted a request.') console.error(error);
  }
});
